import { completed } from "./completed"

export enum LOGIN_EVENTS {
  COMPLETED = "User successfully logs in",
}

export const login = {
  completed,
}
